<template>
    <div class="summary-wrapper">
        <div class="summary-heading">
            <h6>Summary</h6>
        </div>
        <div class="summary-details">
            <h6>{{ eventData.eventName }}</h6>
            <p>{{ eventData.exactStartDate }} to {{ eventData.exactEndDate }}</p>

            <div class="format-wrapper">
                <div class="head">Format</div>
                <p v-if="eventData"> {{ eventData.game_guarantee }} games round robin to seed {{ eventData.eventName }}
                    {{ brackeFormat.toLowerCase() }} bracket.</p>
            </div>

            <div class="age-rating-allow-wrapper">
                <div class="head">Seed Criteria</div>
                <p v-if="selectedSeedCriteria.length">
                    {{selectedSeedCriteria.map(seed => seed.criteria_name).join(', ')}}
                </p>
            </div>

            <div class="age-rating-allow-wrapper">
                <span class="head">Playing Facilities</span>
                <div v-if="selectedParks.length">
                    <div v-for="(park, index) in selectedParks" :key="park.id || index"
                        class="d-flex align-items-center mb-2">
                        <img :src=park_image alt="" />
                        <span class="ml-1">{{ park.park_name }}</span>
                    </div>
                </div>
            </div>

            <div class="age-rating-allow-wrapper">
                <p class="head">Hotels</p>
                <div v-if="eventHotels.length">
                    <div v-for="(hotel, index) in eventHotels" :key="hotel.id || index"
                        class="d-flex align-items-center mb-2">
                        <img :src=hotel_image alt="" class="mr-2" />
                        <span>{{ hotel.name }}</span>
                    </div>
                </div>
            </div>

            <div class="age-rating-allow-wrapper">
                <p class="head">Sponsors</p>
                <div v-if="eventSponsors.length">
                    <div v-for="(sponsor, index) in eventSponsors" :key="sponsor.id || index"
                        class="d-flex align-items-center mb-2">
                        <img :src=sponsor_image alt="" />
                        <span class="ml-1">{{ sponsor.name }}</span>
                    </div>
                </div>
            </div>

            <div class="notes-wrapper">
                <span class="head">Notes</span>
                <p>{{eventData.note}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EventWizardSummary",
    data() {
        return {
            park_image: require("../../../assets/Svg/maximize.svg"),
            sponsor_image: require("../../../assets/Svg/sponsors.svg"),
            hotel_image: require("../../../assets/Svg/hotels.svg")
        }
    },
    props: {
        eventData: {
            type: Object
        },
        brackeFormat: {
            type: String
        },
        selectedSeedCriteria: {
            type: Array,
            default: () => []
        },
        selectedParks: {
            type: Array,
            default: () => []
        },
        eventSponsors: {
            type: Array,
            default: () => []
        },
        eventHotels: {
            type: Array,
            default: () => []
        },
    },
}
</script>